import React from 'react';
import { Button } from 'react-bootstrap';
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css';

const  confirmDelete = (intl, id, secondaryId, deleteF, delHeader) => {
  confirmAlert({
    customUI: ({ onClose }) => {
      return (
        <div className='confirm-delete-modal'>
          <h3>{delHeader}</h3>
          {
            secondaryId ?
            <Button
          variant="primary"
            onClick={() => {
              deleteF(id, secondaryId)
              onClose();
            }}
          >
            {intl.formatMessage({id: 'yes'})}
          </Button> :
            <Button
          variant="primary"
            onClick={() => {
              deleteF(id)
              onClose();
            }}
          >
            {intl.formatMessage({id: 'yes'})}
          </Button>
          }
          <Button variant="default" onClick={onClose}>{intl.formatMessage({id: 'no'})}</Button>
        </div>
      );
    }
  });
};

export default confirmDelete;